import App from './App.svelte';
import packageInfo from '../package.json'
const app = new App({
	target: document.body,
	props: {
		version: packageInfo.version
	}
});

export default app;